/** Not available for Web */
export function useRefreshOnFocus<T>(_refetch: () => Promise<T> | void) {}
